import { connect } from 'react-redux';

import FoldersModal from './FoldersModal';

import {
  saveItems as saveItemsActionCreator,
  removeItems as removeItemsActionCreator,
} from '../../../store/actions/favorites';

export function mapStateToProps(state) {
  const { favorites: { folders } } = state;
  return {
    folderId: folders.active,
    autoAction: folders.savedFolders.length === 1 && folders.savedFolders[0].name === 'Untitled Folder',
    hasFolders: folders.savedFolders.length > 0,
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    saveItems({ items, itemType, folderId }) {
      dispatch(saveItemsActionCreator(items, itemType, folderId));
    },
    removeItems({ items, itemType, folderId }) {
      dispatch(removeItemsActionCreator(items, itemType, folderId));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FoldersModal);



// WEBPACK FOOTER //
// ./src/components/Favorites/FoldersModal/FoldersModalWrapper.js